import { fg } from '@atlaskit/platform-feature-flags/fg';
import { ActionKeys } from '@atlassian/conversation-assistant-message-actions-api/constants';
import type { MessageAction } from '@atlassian/conversation-assistant-service-api/types/message-actions';

export const isArtifactPreviewAction = (action: Pick<MessageAction, 'key'>): boolean =>
	action.key === ActionKeys.ArtifactCreate && fg('rovo_artifacts_library_enabled');
